module.exports = __webpack_public_path__ + "img/sharp-example9.11afdda6.jpg";